import React from 'react';
import { VegaFlex } from "@heartlandone/vega-react";
import { ACTIVITY_STATUS } from 'Chore/Constants';

const { STATUS_LABEL } = ACTIVITY_STATUS;

const ActivityStateindicator = ({ activityStatus }) => {
  const _getClassByStatus = (status) => {
    switch (status) {
      case STATUS_LABEL.NEW:
        return 'bg-light-Background-Accent1-Primary font-light-text-color-primary';
      case STATUS_LABEL.OPEN:
        return 'bg-light-Background-Status-Success font-light-Text-Color-Success';
      case STATUS_LABEL.CLOSED:
        return 'bg-light-Background-Status-Error font-light-Text-Color-Danger-Link';
      default:
        return '';
    }
  }


  return <VegaFlex
    alignItems={'center'}
    gap={'size-4'}
    className={`indicator activity-indicator-border f-size-12 line-height-16 f-weight-400 border-none ${_getClassByStatus(activityStatus)}`}
  >
    <div className={`f-size-14 f-weight-400 line-height-18 `}>{activityStatus}</div>
  </VegaFlex>
};

export default ActivityStateindicator;

